import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../../services/api';
import {
  TextInput,
  Button,
  Group,
  PasswordInput,
  Notification,
  Modal,
  Container,
  Title,
  Text,
  rem,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import API_URL from '../../config';

const LoginPage = ({ setAuthUser }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [userAuthInfo, setUserAuthInfo] = useState('');
  const [LoginSuccess, setLoginSuccess] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);
  const navigate = useNavigate();

  const handleNotificationClose = () => {
    close();
    if (LoginSuccess) {
      navigate('/'); // Redirige vers la page d'accueil si connexion réussie
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post(`${API_URL}/users/token/`, { username, password });
      const { access, refresh, permissions, last_name, first_name, email, photo_url, company } = response.data;
      localStorage.setItem('token', access);
      localStorage.setItem('refreshToken', refresh);
      localStorage.setItem('permissions', permissions);
      localStorage.setItem('last_name', last_name);
      localStorage.setItem('first_name', first_name);
      localStorage.setItem('email', email);
      localStorage.setItem('photo_url', photo_url);
      localStorage.setItem('company', JSON.stringify(company));
      setUserAuthInfo(`${first_name} ${last_name}`);
      setAuthUser(true);
      setLoginSuccess(true);
    } catch (error) {
      console.error('Login error:', error);
      setAuthUser(false);
      setLoginSuccess(false);
      setUserAuthInfo('');
    } finally {
      open();
    }
  };

  return (
    <Container size={420} my={40}>
      <Title align="center" mb="lg">Connexion</Title>
      <Text align="center" color="dimmed" size="sm" mb="xl">
        Connectez-vous pour accéder à votre compte.
      </Text>

      <form onSubmit={handleLogin}>
        <TextInput
          label="Nom d'utilisateur"
          placeholder="Entrez votre nom d'utilisateur"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <PasswordInput
          label="Mot de passe"
          placeholder="Entrez votre mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          mt="md"
          required
        />
        <Group position="apart" mt="md">
          <Text size="sm" color="blue">
            <Link to="/forgot-password">J'ai oublié mon mot de passe</Link>
          </Text>
          <Button type="submit" variant="filled" color="blue">
            Se connecter
          </Button>
        </Group>
      </form>

      <Modal opened={opened} onClose={handleNotificationClose} title="Authentification" centered>
        <Notification
          color={LoginSuccess ? 'teal' : 'red'}
          title={LoginSuccess ? 'Connexion réussie !' : 'La connexion a échoué !'}
          onClose={handleNotificationClose}
          mt="md"
        >
          {LoginSuccess ? `Bonjour ${userAuthInfo}` : "L'utilisateur n'existe pas ou les informations sont incorrectes."}
        </Notification>
      </Modal>
    </Container>
  );
};

export default LoginPage;